import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import SingleChatScreen1 from "../SingleChat/index1";
import NoData from "Components/NoData";

const ChatWindowComponent = (props: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { selectedCase, setShowChatList } = props;
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#ffffff",
          height: "100%",
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        {selectedCase ? (
          <>
            {isMobile && (
              <Box sx={{ p: 1, backgroundColor: "#fff", flexShrink: 0 }}>
                <Typography
                  variant="body2"
                  sx={{ cursor: "pointer", color: "primary.main" }}
                  onClick={() => setShowChatList(true)}
                >
                  ← Back to Case List
                </Typography>
              </Box>
            )}
            <Box sx={{ flex: 1, overflow: "hidden" }}>
              <SingleChatScreen1 selectedCase={selectedCase} />
            </Box>
          </>
        ) : (
          <NoData cstmMsg="Please Select a case to start Chat." />
        )}
      </Box>
    </>
  );
};

export default ChatWindowComponent;
